<template>
    <span>{{ Translations.sections.boxes.sectionTitle }}</span>
</template>

<script>
    import Vue from 'vue';
    import { mapState, mapActions } from 'vuex'
    import store from '@/store/index.js'
    import Bootstrap from 'bootstrap-vue'
    import Translations from '@/store/translations';

    Vue.use(Bootstrap);

    export default {
        name: "BoxSectionHeader",
        store,
        components: {
        },
        computed: {
            Translations: () => Translations,
        },
        data() {
            return {}
        }
    }
</script>

<style scoped>
</style>
